<template>
  <modal-template
    ref="modal"
    :title="title"
    type-modal="add_obligations_modal"
  >
    <div class="modal-content__main">
      <ul class="list-inline">
        <li
          v-for="(item, index) in list"
          :key="index"
          :class="[!item.selected ? 'no-content' : '', 'contract-detail text-left d-flex pr-3']"
        >
          <d-checkbox
            toggle
            @change="toggleItem(item)"
            :checked="item.selected"
            class="custom-toggle-sm"
          >
          </d-checkbox>
          <div @click="toggleItem(item)" v-html="item.name" v-if="item.name"></div>
        </li>
      </ul>
    </div>
    <div slot="actions" class="modal-content__control" >
      <loader v-if="loading" :fullPage="false" class="mr-4"/>
      <d-button
        type="button"
        :disabled="loading"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Inserir</d-button>
    </div>
  </modal-template>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { OPTION } from '_modules/settings/components/SettingsModel';
import Loader from '_shared/Loader.vue';
import ModalTemplate from '_shared/Modal.vue';
import { _OPEN_OBLIGATION_MODAL_, _SET_OBLIGATION_IN_QUOTATION_ } from '../QuotationModel';

export default {
  name: 'contractual-items-select-modal',
  data() {
    return {
      list: [],
      type: null,
      index: null,
      loading: false,
    };
  },
  components: {
    Loader,
    ModalTemplate,
  },
  computed: {
    hired() {
      const { hired } = this.$store.state.settings;
      if (hired && hired.length > 0) {
        return hired;
      }
      return [{ ...OPTION }];
    },
    title() {
      return this.type === 'itemsIncluded' ? 'Selecionar Itens Inclusos' : 'Selecionar obrigações';
    },
    contractor() {
      const { contractor } = this.$store.state.settings;
      if (contractor && contractor.length > 0) {
        return contractor;
      }
      return [{ ...OPTION }];
    },
    itemsIncluded() {
      const { itemsIncluded } = this.$store.state.settings;
      if (itemsIncluded && itemsIncluded.length > 0) {
        return itemsIncluded;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    toggleItem(item) {
      item.selected = !item.selected;
    },
    save() {
      let obligation = '';
      this.list.forEach(row => {
        if (row.selected) {
          obligation += row.name;
        }
      });
      Events.$emit(_SET_OBLIGATION_IN_QUOTATION_, ({ obligation, type: this.type, index: this.index }));
      this.setToggle({ type: 'add_obligations_modal', bool: false });
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_OPEN_OBLIGATION_MODAL_, ({ type, index }) => {
      this.type = type;
      this.list = this[type];
      this.index = index;
    });
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px;
  }
}
</style>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
.contract-detail {
  cursor: pointer;
  /deep/ p {
    margin-bottom: 10px;
  }
}
</style>
